:host {
  display: inline-flex;
  position: relative;

  &.is_shown {
    .button_popover {
      &:before {
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        content: '';
      }
    }

    .popover {
      display: block;
    }
  }
}

.popover {
  min-width: 200px;
  position: absolute;
  top: 100%;
  right: 0;
  border-radius: 4px;
  z-index: 1;
  box-shadow: var(--pv-shadow-light-medium);
  background: var(--pv-color-white);
  padding: calc(var(--pv-size-base) * 2) 0;
  margin: var(--pv-size-base) 0;
  display: none;
}

.button_option {
  width: 100%;
  justify-content: flex-start;
  border-radius: 0;
}

.group {
  &:not(:last-child) {
    border-bottom: 1px solid var(--pv-color-gray-5);
    padding-bottom: calc(var(--pv-size-base) * 2);
    margin-bottom: var(--pv-size-base);
  }
}

.group_title {
  line-height: calc(var(--pv-size-base) * 6);
  padding: 0 calc(var(--pv-size-base) * 2);
}
